const badgeStyles = {
  autorizado: { bg: "#ECFDF5", color: "#065F46", dot: "#10B981" },
  derivado: { bg: "#FFFBEB", color: "#92400E", dot: "#F59E0B" },
  noAutorizado: { bg: "#FEF2F2", color: "#991B1B", dot: "#EF4444" },
  iniciado: { bg: "#F5F3FF", color: "#5B21B6", dot: "#8B5CF6" },
  default: { bg: "#F3F4F6", color: "#374151", dot: "#9CA3AF" },
};

const resolveEstadoBadge = (label) => {
  const normalized = String(label || "").toUpperCase();
  if (normalized.includes("NO_AUTORIZ") || normalized.includes("NO AUTORIZ") || normalized.includes("RECHAZ")) {
    return badgeStyles.noAutorizado;
  }
  if (normalized.includes("AUTORIZ")) {
    return badgeStyles.autorizado;
  }
  if (normalized.includes("DERIV")) {
    return badgeStyles.derivado;
  }
  if (normalized.includes("INICIADO")) {
    return badgeStyles.iniciado;
  }
  return badgeStyles.default;
};

export function Spinner() {
  return (
    <div className="tx-spinner-wrap">
      <div className="tx-spinner" />
    </div>
  );
}

export function SortIcon({ direction }) {
  if (!direction)
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ opacity: 0.3 }}>
        <path d="M6 2L9 5H3L6 2ZM6 10L3 7H9L6 10Z" fill="currentColor" />
      </svg>
    );
  return direction === "asc" ? (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M6 2L10 7H2L6 2Z" fill="#B04708" />
    </svg>
  ) : (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M6 10L2 5H10L6 10Z" fill="#B04708" />
    </svg>
  );
}

export function Badge({ label }) {
  const s = resolveEstadoBadge(label);
  return (
    <span className="tx-badge" style={{ background: s.bg, color: s.color }}>
      <span className="tx-badge-dot" style={{ background: s.dot }} />
      {label}
    </span>
  );
}

export function Field({ label, children }) {
  return (
    <div className="tx-field">
      <label className="tx-field-label">{label}</label>
      {children}
    </div>
  );
}
